import Collection from 'core/model/Collection';
import McpServerModel from './McpServerModel';

class McpServerCollection extends Collection {
  get url() {
    return '/api/ui/ai/mcp-servers';
  }

  get model() {
    return McpServerModel;
  }
}

export default McpServerCollection;
